<template>
  <div>
    <div class="card" v-loading="isLoading">
      <div class="card-header">
        <h5 class="card-title">Storage Locations</h5>
        <p-button type="info" size="sm" @click.prevent="goAddStorageLocation()">Add Storage Location</p-button>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table :data="storageLocations" header-row-class-name="text-primary">
            <el-table-column prop="storage_facility.name"
                             label="Warehouse">
            </el-table-column>
            <el-table-column prop="barcode_id"
                             label="Barcode ID">
            </el-table-column>
            <el-table-column prop="name"
                             label="Name">
            </el-table-column>
            <el-table-column
              class-name="action-buttons td-actions"
              align="right"
              label="Actions">
              <template slot-scope="props">
                <p-button type="success" size="sm" icon @click="handleEdit(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Swal from 'sweetalert2';
  import {Table, TableColumn} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import { mapGetters, mapActions } from 'vuex'
  import { NotifyMixin } from 'src/mixins/notify.mixin'
  import { ErrorFromatterMixin } from 'src/mixins/errorFormatter.mixin'
  import StorageLocationService from 'src/services/ProviderAccount/storageLocation.service'
  Vue.use(Table)
  Vue.use(TableColumn)
  export default{
    components: {
      PSwitch
    },
    mixins: [NotifyMixin, ErrorFromatterMixin],
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
    data () {
      return {
        isLoading: true,
        storageLocations: []
      }
    },
    methods: {
      ...mapActions({
        me: 'auth/me'
      }),
      init () {
        this.isLoading = true
        this.loadStorageLocations()
      },
      async loadStorageLocations () {
        let response = await StorageLocationService.index()
        this.storageLocations = response.data
        this.isLoading = false
      },
      goAddStorageLocation () {
        this.$router.replace({ name: 'Add Storage Location' })
      },
      handleEdit (index, row) {
        this.$router.push({ name: 'Edit Storage Location', params: { id: row.id } })
      },
      handleDelete (index, row) {
        const swalWithBootstrapButtons4 = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons4
          .fire({
            title: `Are you sure?`,
            text: `${row.name} will be permanently deleted!`,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            showCancelButton: true,
          })
          .then((result) => {
            if (result.value) {
              this.deleteStorageLocation(row)
            }
          });
      },
      async deleteStorageLocation (storageLocation) {
        try {
          this.isLoading = true
          await StorageLocationService.destroy(storageLocation.id)
          this.showNotify('Storage Location deleted', 'success', 'Success')
          this.isLoading = false
          this.init()
        } catch (e) {
          let msg = this.errorMsgFromResponse(e.response)
          this.showNotify(msg, 'danger', 'Failed')
          this.isLoading = false
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }
</style>
